import Data from "../../data/interview_call_logo.json";
import { useState } from "react";

function MentorsProfile({ytUrl}) {
  const [visible, setVisible] = useState(false);

  return (
    <div className="mentor-profile my-5 container text-center">
      <h3 style={{ fontSize: 14 }}>Our Data Science Course Industry Mentors Demo Class</h3>
      <div className="card flex-lg-row align-items-lg-center my-5">
        <div className="card-header">
        <div className="border-layer">
          <div className="wrapper d-flex position-relative">
            {!visible ? (<>
              <div className="left d-flex align-items-center">
                <p className="pl-2 pl-lg-4 text-lg text-white md:text-2xl">
                  Demo Class
                  <br />
                  <span className="text-red underline">Head instructor</span>
                  <br />
                  For Current Batch
                </p>
              </div>
              <div className="right">
                <img
                  src="assets/images/mentor/monesh.jpg"
                  alt=""
                  class="h-full"
                />
              </div>
              <div className="play-btn position-absolute d-flex justify-content-center align-items-center">
                <button onClick={() => setVisible(true)} className="btn d-flex justify-content-center align-items-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg" fill="none" stroke-width="2" stroke="currentColor" height="20" width="20"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M5.25 5.653c0-.856.917-1.398 1.667-.986l11.54 6.347a1.125 1.125 0 0 1 0 1.972l-11.54 6.347a1.125 1.125 0 0 1-1.667-.986V5.653Z"
                    />
                  </svg>
                </button>
              </div>
              </>
            ) : (<iframe
                width="560"
                height="315"
                src={ytUrl}
                title="YouTube video player"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen; web-share"
                referrerpolicy="strict-origin-when-cross-origin"
                allowfullscreen
              ></iframe>)}
            </div>
          </div>
        </div>
        <div className="card-body d-flex flex-column align-items-left">
          <div className="lable rounded">
            <p>Head Instructor</p>
          </div>
          <div className="profile d-flex mt-3 mb-1">
            <figure>
              <img src="assets/images/mentor/monesh.jpg" />
            </figure>
            <div className="title">
              <div className="meta-profile d-flex align-items-center">
                <h4 style={{ fontSize: 17 }}
                >Monesh Venkul Vommi</h4>
                <a href="https://www.linkedin.com/in/monesh-venkul-vommi-8a80b6174/" target="_blank">
                  <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 16 16" class="bg-white text-[#0077B6]" height="18" width="18" xmlns="http://www.w3.org/2000/svg"><path d="M0 1.146C0 .513.526 0 1.175 0h13.65C15.474 0 16 .513 16 1.146v13.708c0 .633-.526 1.146-1.175 1.146H1.175C.526 16 0 15.487 0 14.854V1.146zm4.943 12.248V6.169H2.542v7.225h2.401zm-1.2-8.212c.837 0 1.358-.554 1.358-1.248-.015-.709-.52-1.248-1.342-1.248-.822 0-1.359.54-1.359 1.248 0 .694.521 1.248 1.327 1.248h.016zm4.908 8.212V9.359c0-.216.016-.432.08-.586.173-.431.568-.878 1.232-.878.869 0 1.216.662 1.216 1.634v3.865h2.401V9.25c0-2.22-1.184-3.252-2.764-3.252-1.274 0-1.845.7-2.165 1.193v.025h-.016a5.54 5.54 0 0 1 .016-.025V6.169h-2.4c.03.678 0 7.225 0 7.225h2.4z"></path></svg>
                </a>
              </div>
              <div className="meta-tags d-flex flex-column flex-md-row">
                <div className="lable rounded d-flex">
                  <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 1024 1024" height="20" width="20" xmlns="http://www.w3.org/2000/svg"><path d="M990.848 696.304V438.16l16.096-8.496c10.464-5.44 17.055-16.225 17.183-28.032.128-11.777-6.256-22.689-16.592-28.368l-481.44-257.6c-9.631-5.28-21.28-5.249-30.976.095l-478.8 257.92C6.126 379.36-.177 390.143-.113 401.84s6.496 22.4 16.817 27.97l210.384 111.983c-2.64 4.656-4.272 9.968-4.272 15.696v270.784c0 9.12 3.905 17.84 10.72 23.904 6.945 6.16 73.441 60.096 276.753 60.096 202.592 0 270.88-50.976 278-56.784 7.44-6.064 11.744-15.152 11.744-24.784V552.976c0-4.496-.944-8.768-2.608-12.64l129.424-68.369V696.48c-18.976 11.104-31.84 31.472-31.84 55.024 0 35.344 28.656 64 64 64s64-28.656 64-64c0-23.697-13.04-44.145-32.16-55.2zM736.031 812.368c-25.152 12.096-91.712 35.904-225.744 35.904-134.88 0-199.936-25.344-223.472-37.536V573.6l207.808 110.624a31.896 31.896 0 0 0 15.184 3.84 31.675 31.675 0 0 0 14.816-3.664l211.408-111.664v239.632zM510.063 619.81l-411.6-218.561 412.32-220.976 413.6 220.336z"></path></svg>
                  <p>University of New Haven/IIT Alumni</p>
                </div>
                <div className="lable rounded d-flex">
                  <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" height="20" width="20" xmlns="http://www.w3.org/2000/svg"><g id="Monitor"><path d="M18.435,3.06H5.565a2.5,2.5,0,0,0-2.5,2.5v8.88a2.507,2.507,0,0,0,2.5,2.5h2.91l-.37,3H7a.5.5,0,0,0,0,1h10.01a.5.5,0,0,0,0-1H15.9l-.37-3h2.91a2.507,2.507,0,0,0,2.5-2.5V5.56A2.5,2.5,0,0,0,18.435,3.06ZM14.9,19.94H9.115l.37-3h5.03Zm5.04-5.5a1.5,1.5,0,0,1-1.5,1.5H5.565a1.5,1.5,0,0,1-1.5-1.5V5.56a1.5,1.5,0,0,1,1.5-1.5h12.87a1.5,1.5,0,0,1,1.5,1.5Z"></path></g></svg>
                  <p>6+ yrs experience</p>
                </div>
              </div>
            </div>
          </div>
          <p>Monesh has over 6+ years of experience as a Data Scientist and Senior Machine Learning Engineer at renowned organizations, contributing to various projects in Generative AI and Data Science. He also has more than 4+ years of teaching experience as a corporate trainer.</p>
          <div className="companies d-flex justify-content-start align-items-center flex-wrap">
            {/*
            <figure>
              <img src="assets/images/company_logo/almabetter.png" />
            </figure>
            <figure>
              <img src="assets/images/company_logo/blackbuck.png" />
            </figure>
            <figure>
              <img src="assets/images/company_logo/american_express.png" />
            </figure>
            */}
          </div>
        </div>
      </div>
    </div>
  );
}
export default MentorsProfile;
